import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

const PortalProtector = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { isLoggedIn, data: userData } = useSelector((state) => state.user) || {};

  useEffect(() => {
    const isInfluencerLoc = location.pathname?.includes('influencer');
    const isCreatorLoc = location.pathname?.includes('creator');
    const isAdminLoc = location.pathname?.includes('admin');
    const isAiTripPlanEditorLoc = location.pathname?.includes('itinerary-ai-plan-editor');
    const aiTripPlanId = searchParams.get('ai-trip-plan');

    if (!isLoggedIn) {
      if (isAiTripPlanEditorLoc && aiTripPlanId) {
        navigate(`/preview/ai-trip?ai-trip-plan=${aiTripPlanId}`);
      } else if (isCreatorLoc) {
        navigate('/creator/login');
      } else if (isInfluencerLoc) {
        navigate('/influencer/login');
      } else {
        navigate('/login');
      }
    } else if (
      ((isInfluencerLoc || isCreatorLoc) && userData.userType !== 'influencer' && userData.userType !== 'creator') ||
      (isAdminLoc && userData.userType !== 'admin')
    ) {
      // navigate('/my-apps');
    }
  }, [isLoggedIn, navigate, location, userData, searchParams]);

  return children;
};

export default PortalProtector;
